import type { ReactNode } from 'react';

export const symbol_cottage: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-180v-341l-60 46q-10.35 8-22.17 6Q66-471 58-481q-8-10-6-22t12-20l96-73v-84q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v38l224-170q16.21-12 36.11-12Q500-824 516-812l381 290q9.94 7.62 11.47 19.81Q910-490 902-479.63q-8 9.63-19.5 11.13T861-475l-61-46v341q0 24.75-17.62 42.37Q764.75-120 740-120H220q-24.75 0-42.37-17.63Q160-155.25 160-180Zm60 0h230v-130q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v130h230v-387L480-765 220-567v387Zm0 0h520-520Zm-25-580q-15 0-24.5-11t-4.5-24q11-34 40.06-54.5Q235.13-870 270-870q14 0 26-7.07T314-897q5-9 12.5-16t18.5-7q15 0 24.5 11t4.5 24q-12 34-40.75 54.5T270-810q-14 0-25.5 7.5T226-783q-5 9-12.7 16-7.71 7-18.3 7Z"
		/>
	</svg>
);
